import * as z from "zod";

// Schema only, so front ends can type it without bundling the whole tree in industries.ts.

const industryCategoryRefSchema = z
  .object({
    id: z.uuid(),
    slug: z.string(),
    name: z.string(),
  })
  .strict();

/** An industry category as the API returns it: the node, its path of names from the top, and the anchor templates use. */
export const industryCategoryWireSchema = industryCategoryRefSchema
  .extend({
    path: z
      .array(z.string())
      .describe("Names from the top level down, ending with this category."),
    anchor: industryCategoryRefSchema
      .nullable()
      .describe(
        "The nearest high-level category at or above this one; onboarding, templates and workflows use it.",
      ),
  })
  .strict()
  .describe("IndustryCategory");

export type IndustryCategoryWire = z.infer<typeof industryCategoryWireSchema>;

/** An industry category in a picker: the category plus whether it can be opened to narrower ones. */
export const industryCategoryOptionSchema = industryCategoryWireSchema
  .extend({
    hasChildren: z
      .boolean()
      .describe("True when narrower categories sit under this one."),
  })
  .strict()
  .describe("IndustryCategoryOption");

export type IndustryCategoryOption = z.infer<
  typeof industryCategoryOptionSchema
>;
